import styled from "styled-components";
import { media } from "../../breakpoints";

export const Wrapper = styled.div`
     padding: 34px 34px 60px 34px;
    background: #ffffff;
    margin: 37px 90px 0 90px;
    border-radius: 20px;

    ${media.desktop`
        margin: 24px 24px 0;
    `}

    ${media.tablet`
        margin: 16px 12px 0;
        padding: 20px 12px 40px;
    `}
`